import { HostListener, Component, Inject, OnInit } from '@angular/core';
import { PageComponent } from '../page/page.component';
import { GlobalsService } from '../../services/globals.service';
import { StorageService } from '../../services/storage.service';
import { ViasConnectionService, ViasResponse } from '../../services/vias-connection.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { PageMeta, ResponseField, ResponseFieldDataSourceType, PageMetaService } from '../../services/page-meta.service';
import { DataGridEvent } from '../datagrid/datagrid.component';
import { ButtonBarItem } from '../buttonbar/buttonbar.component';
import { FilterOptions, DataGridColumn } from '../datagrid/datagrid.component';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogFields } from '../../services/vias-dialog.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'vias-default-list-page',
  templateUrl: '../page/page.component.html',
  styleUrls: ['../page/page.component.scss']
})
export class DefaultListPageComponent extends PageComponent {
  constructor(
    protected storage: StorageService,
    protected globals: GlobalsService,
    protected viasService: ViasConnectionService,
    protected next: ActivatedRoute,
    protected route: Router,
    protected translate: TranslateService,
    public tableDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) protected dialogData: {} = {},
    protected dialogRef: MatDialogRef<DefaultListPageComponent>,
  ) {
    super(storage, globals, viasService, next, route, translate, dialogData);
    this.hasDatagrid = true;
    this.hasEditForm = false;
  }

  generatePageFromMeta(pageMeta: PageMeta): void {
    // parent cagir
    super.generatePageFromMeta(pageMeta);
    this.aid = pageMeta.listAid;
    this.hasButtonbar = pageMeta.hasButtonBarInList;
    this.dgButtons = {
      hasAddBtn: pageMeta.datagridHasAddBtn,
      hasEditBtn: pageMeta.datagridHasEditBtn,
      editBtnText: pageMeta.datagridEditBtnText,
      hasDeleteBtn: pageMeta.datagridHasDeleteBtn
    };
    if (pageMeta.dataGridInitialSort) {
      this.sortObj = pageMeta.dataGridInitialSort;
    }
    this.datagridOptions['hasSelectButton'] = this.pageMeta.hasSelectButton;
    this.datagridOptions['multipleRowSelection'] = this.pageMeta.hasMultiSelectDataGrid;
    if (this.data$ !== undefined) {
      if (this.data$['initDataFields']) {
        pageMeta.initDataFields = {
          ...pageMeta.initDataFields,
          ...this.data$['initDataFields']
        };
      }
      if (this.data$['initDataFieldsForFilterObject']) {
        pageMeta.initDataFieldsForFilterObject = {
          ...pageMeta.initDataFieldsForFilterObject,
          ...this.data$['initDataFieldsForFilterObject']
        };
      }
    }

    if (pageMeta.initDataFieldsForFilterObject !== undefined) {
      this.filtersObj = pageMeta.initDataFieldsForFilterObject;
    }

    this.refreshData();
  }

  viasServiceHandler(r: ViasResponse): void {
    super.viasServiceHandler(r);
    if (r.data !== undefined) {
      const resp = this.responseFieldParserForDataGrid(
        r.data,
        this.pageMeta.responseFields,
        this.pageMeta.dataGridColumns
      );
      this.dataSource = resp.dataSource;
      this.columns = resp.dataGridColumns;
      // this.pageMeta.responseFields.forEach(rf => {
      //   if (rf.responseFieldType === ResponseFieldDataSourceType.datagridDataSource) {
      //     if (r.data[rf.fieldName] !== undefined) {
      //       this.dataSource = r.data[rf.fieldName];
      //     }
      //   } else if (rf.responseFieldType === ResponseFieldDataSourceType.datagridFilterDataSource) {
      //     // colonu bul
      //     const colInd: number = this.pageMeta.dataGridColumns.findIndex(
      //       x => x.filterField === rf.componentName
      //     );
      //     const col: DataGridColumn = this.pageMeta.dataGridColumns[colInd];
      //     // seciniz ekle
      //     col.filterDataSource = [{ value: 0, label: 'Seçiniz' } as FilterOptions];
      //     // digerlerini ekle
      //     r.data[rf.fieldName].forEach(obj => {
      //       col.filterDataSource.push({
      //         value: obj[col.filterDataIdField],
      //         label: obj[col.filterDataLabelField]
      //       });
      //     });
      //     // changed lifecyle icin
      //     // kolonu geri yaz
      //     this.pageMeta.dataGridColumns.splice(colInd, 1, col);
      //   }
      // });

      if (r.data[this.pageMeta.pageTotalsField] !== undefined) {
        this.totalPages = r.data[this.pageMeta.pageTotalsField];
        this.datagridOptions['totalPages'] = this.totalPages;
      }
      if (r.data[this.pageMeta.pageNoField] !== undefined) {
        this.pageno = r.data[this.pageMeta.pageNoField];
        this.datagridOptions['pageno'] = this.pageno;
      }

      // islem bitti colonlari gonder
      this.columns = this.pageMeta.dataGridColumns;
    }
  }

  datagridDoubleClickHandler(event: DataGridEvent): void {
    if (this.pageMeta.hasSelectButton) {
      this.datagridSelectBtnClickHandler(event);
    } else {
      this.datagridEditBtnClickHandler(event);
    }
  }

  datagridSelectBtnClickHandler(event: DataGridEvent): void {
    if (this.fromDialog) {
      this.dialogRef.close({ data: event });
    } else {
      let prevPageData;
      if (this.route['lastSuccessfulNavigation'].previousNavigation.extras.queryParams) {
        prevPageData = this.route['lastSuccessfulNavigation'].previousNavigation.extras.queryParams.page_data;
      } else {
        prevPageData = this.route['lastSuccessfulNavigation'].previousNavigation.extractedUrl.queryParams;
      }
      const navigationExtras: NavigationExtras = {
        queryParams: {
          page_data: prevPageData,
          return_data: event.selectedItems
        }
      };
      const prevUrl = this.route['lastSuccessfulNavigation'].previousNavigation.extractedUrl.root.children.primary.segments;
      if (prevUrl.length === 2) {
        this.route.navigate(['/' + prevUrl[0].path + '/' + prevUrl[1].path], navigationExtras);
      }
    }
  }
  datagridAddBtnClickHandler(event: DataGridEvent): void {
    console.log(this.pageMeta.editPageName);
    const passedData = { aid: this.pageMeta.addAid };
    const navigationExtras: NavigationExtras = {
      queryParams: passedData
    };
    this.route.navigate(
      ['/' + this.moduleName + '/' + this.pageMeta.editPageName],
      navigationExtras
    );
  }
  datagridEditBtnClickHandler(event: DataGridEvent): void {
    if (this.pageMeta.passedDataFields !== undefined) {
      const passedData = { aid: this.pageMeta.editAid };
      this.pageMeta.passedDataFields.forEach(pd => {
        if (pd.value !== undefined) {
          passedData[pd.dbQueryField] = pd.value;
        } else {
          passedData[pd.dbQueryField] = event.item[pd.datagridField];
        }
      });
      const navigationExtras: NavigationExtras = {
        queryParams: passedData
      };
      // eger # ile geliyor ise adres veriyordur
      // orn
      // editPageName = '#repair-planning/edit-project';
      if (this.pageMeta.editPageName.charAt(0) === '#') {
        // kullanirken bastaki # isaretini kaldiracagiz
        this.route.navigate(
          [this.pageMeta.editPageName.substr(1)],
          navigationExtras
        );
      } else {
        this.route.navigate(
          ['/' + this.moduleName + '/' + this.pageMeta.editPageName],
          navigationExtras
        );
      }
    }
  }
  datagridDeleteBtnClickHandler(event: DataGridEvent): void {
    console.log(event.item);
    if (event.item !== undefined) {
      this.tableDialog.open(ConfirmationDialogComponent, {
        panelClass: 'pageDialog',
        data: {
          question: 'willbedeleted',
          confirmText: 'delete',
          rejectText: 'rejectAction'
        }
      })
        .afterClosed()
        .subscribe(r => {
          if (r !== undefined) {
            if (r.confirm) {
              this.viasService.send(this.pid, this.pageMeta.deleteAid, event.item).then(
                response => {
                  if (response.error !== null && response.error !== undefined && response.error.length > 0) {
                    this.globals.handleErrors(response.error);
                  }
                  this.viasServiceHandler(response);
                },
                err => {
                  alert(err);
                  console.log(err);
                });
            }
          }
        });
    }
  }
  butonclickHandler(event: ButtonBarItem): void {
    if (event.onClick) {
      event.onClick(event, this.datagridSelectedItem, this.pageMeta, this.route, 
        this.translate, this.storage, this.globals, this.viasService, this.tableDialog,this.filtersObj
      );
    }
  }
}
